// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df61e9a6","726":"b23184c3"}[chunkId] + ".chunk.js";
};